import { Button, Icon } from '@user-portal/wikr-components';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { SUBSCRIPTION_LABEL_STATES } from '../constants';
import { IExpiresSoonSubscription } from '../types';

import AdditionalStatusInfo from './subComponents/AdditionalStatusInfo';
import BillingPeriod from './subComponents/BillingPeriod';
import { IncludedInYourPlanRow } from './subComponents/IncludedInYourPlanRow';
import PeriodRow from './subComponents/PeriodRow';
import PriceRow from './subComponents/PriceRow';
import SubscriptionCardHeader from './subComponents/SubscriptionCardHeader';
import SubscriptionStatusLabel from './subComponents/SubscriptionLabel';
import SubscriptionCardWrapper from './SubscriptionCardWrapper';

import * as S from './styled';

const ExpiresSubscription = ({
    tabIcon,
    heading,
    subscriptionPeriod,
    price,
    isTrial,
    isUpgrade,
    isMainSubscription,
    productCode,
    captions,
    onShowReturnOffer,
    isOfferAvailableForSubscription,
    isReturnOfferApplied,
    isOneTimeProduct,
    isPromoCodeUsed,
}: IExpiresSoonSubscription) => {
    const { t } = useTranslation();
    const isReturnOfferNeeded =
        !isReturnOfferApplied && isOfferAvailableForSubscription && !isOneTimeProduct && !isPromoCodeUsed;

    return (
        <SubscriptionCardWrapper>
            <SubscriptionCardHeader
                isMainSubscription={isMainSubscription}
                productCode={productCode}
                Icon={tabIcon}
                heading={heading}
            />

            <SubscriptionStatusLabel state={SUBSCRIPTION_LABEL_STATES.CANCELED} />
            <PeriodRow period={subscriptionPeriod} isTrial={isTrial} />
            <PriceRow price={price} />
            <BillingPeriod period={subscriptionPeriod} />
            {isUpgrade && <IncludedInYourPlanRow isCardRow />}
            <S.Line $mt={16} />
            {(captions?.title || captions?.description) && <AdditionalStatusInfo captions={captions} />}
            {isReturnOfferNeeded && (
                <>
                    <S.Disclaimer>
                        <Icon name="info" color="text-secondary-subdued" size={24} />
                        <S.SubscriptionDisclaimer type="medium-text" color="text-secondary" mb={10}>
                            {t('subscription.management.description')}
                        </S.SubscriptionDisclaimer>
                    </S.Disclaimer>
                    <Button dataLocator="showReturnOfferBtn" onClick={onShowReturnOffer}>
                        {t('subscription.text.showReturnOffer')}
                    </Button>
                </>
            )}
        </SubscriptionCardWrapper>
    );
};

export default ExpiresSubscription;
